import React from 'react';
import { Box, Skeleton, Grid, Typography } from '@mui/material';

const PageSkeletonPromoCodes = () => {
  return (
    <div>
      <Grid container xs={12} justifyContent="center">
        {/* Header Section */}


        {/* Desktop Table View */}
        <Box
          sx={{
            display: { xs: 'none', lg: 'flex' },
            width: '100%'
          }}
        >
          <Grid container>
            <Box sx={{ 
              width: '100%',
              border: '1px solid #E4EBF6',
              borderRadius: '10px',
              backgroundColor: '#fff',
              mb: 2
            }}>
              {/* Table Header */}
              <Grid container sx={{ borderBottom: '1px solid #E4EBF6', p: 2 }}>
                <Grid item xs={3}><Skeleton width={60} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                <Grid item xs={2}><Skeleton width={60} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                <Grid item xs={2}><Skeleton width={60} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                <Grid item xs={2}><Skeleton width={60} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                <Grid item xs={2}><Skeleton width={60} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                <Grid item xs={1}><Skeleton width={40} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
              </Grid>

              {/* Table Body */}
              {[...Array(5)].map((_, index) => (
                <Grid container key={index} sx={{ p: 2, '&:hover': { backgroundColor: '#E6EDF9' } }}>
                  <Grid item xs={3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      {/* <Skeleton width={100} sx={{ bgcolor: '#E6EDF9' }} /> */}
                      <Skeleton width={120} height={20} sx={{ borderRadius: '4px', bgcolor: '#E6EDF9' }} />
                      {/* <Skeleton width={80} height={30} sx={{ borderRadius: '4px', bgcolor: '#E6EDF9' }} /> */}
                    </Box>
                  </Grid>
                  <Grid item xs={2}><Skeleton width={40} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                  <Grid item xs={2}><Skeleton width={60} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                  <Grid item xs={2}><Skeleton width={80} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                  <Grid item xs={2}><Skeleton width={60} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                  <Grid item xs={1}><Skeleton width={50} sx={{ bgcolor: '#E6EDF9' }} /></Grid>
                </Grid>
              ))}
            </Box>
          </Grid>
        </Box>

        {/* Mobile Accordion View */}
        <Box
          sx={{
            display: { xs: 'flex', lg: 'none' },
            width: '100%'
          }}
        >
          <Grid container spacing={2}>
            {[...Array(5)].map((_, index) => (
              <Grid item xs={12} key={index}>
                <Box sx={{ 
                  p: 2,
                  border: '1px solid #E4EBF6',
                  borderRadius: '8px',
                  backgroundColor: '#fff'
                }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Skeleton width={100} sx={{ bgcolor: '#E6EDF9' }} />
                    <Skeleton width={80} sx={{ bgcolor: '#E6EDF9' }} />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Skeleton width={80} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
                    <Skeleton width={60} sx={{ bgcolor: '#E6EDF9' }} />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Skeleton width={80} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
                    <Skeleton width={100} sx={{ bgcolor: '#E6EDF9' }} />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Skeleton width={80} sx={{ mb: 1, bgcolor: '#E6EDF9' }} />
                    <Skeleton width={120} sx={{ bgcolor: '#E6EDF9' }} />
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                    <Skeleton width={70} height={35} sx={{ bgcolor: '#E6EDF9' }} />
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Skeleton width={90} height={35} sx={{ bgcolor: '#E6EDF9' }} />
                      <Skeleton width={90} height={35} sx={{ bgcolor: '#E6EDF9' }} />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Grid>
    </div>
  );
};

export default PageSkeletonPromoCodes;
